import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "danger-outline" | "ghost" | "dark";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  icon?: ReactNode;
  fullWidth?: boolean;
};

const variantClasses: Record<Variant, string> = {
  primary: "bg-primary text-white shadow-primary-btn",
  secondary: "bg-surface text-primary border-[1.5px] border-primary",
  "danger-outline": "bg-surface text-danger-deep border-[1.5px] border-danger-border",
  ghost: "bg-transparent text-primary",
  dark: "bg-contrast text-on-contrast",
};

export function Button({
  variant = "primary",
  icon,
  fullWidth,
  className = "",
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      type="button"
      className={`flex h-12 items-center justify-center gap-2 rounded-pill px-6 text-[15px] font-semibold ${
        fullWidth ? "w-full" : ""
      } ${variantClasses[variant]} disabled:bg-surface-muted disabled:text-text-faint-2 disabled:shadow-none ${className}`}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}
